export const dashboardsKeys = {
    DASHBOARDS_READ: 'dash/read',
};